module.exports = "/_next/static/images/welcome-transfez-payroll-8784f3fc09673a8e970e90c31faa9a3d.png";